module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"modal_title":"Выберите язык","print_check":"Распечатать","language_placeholder":"Язык"},"en":{"modal_title":"Select language","print_check":"Print","language_placeholder":"Language"}}')
  delete Component.options._Ctor
}
